import { getFirestore, collection, query, getDocs, onSnapshot } from "firebase/firestore"
import getCollectionPath from '@/services/firestore/getCollectionPath'
import catalogueCommands from '@/commands/catalogueCommands'

const db = getFirestore()
const collectionName = 'hrstatus/'

function docToInstance(document) {
  const data = document.data()
  return data ? new HrStatus(document.id, data.name, data.description, data.color, data.sex, data.jobs, data.happiness, data.duration, data.durationUnit, data.costMultiplicator,data.productivityMultiplicator, data.outAtEnd, data.outNow, data.overwrite, data.appearanceRate, data.appearanceRule, data.available) : null
}

export default class HrStatus {
  constructor(id, name, description, color, sex, jobs, happiness, duration, durationUnit, costMultiplicator, productivityMultiplicator, outAtEnd, outNow, overwrite, appearanceRate, appearanceRule, available = true) {
    this.id = id
    this.name = name
    this.description = description
    this.color = color
    this.sex = sex
    this.jobs = jobs
    this.happiness = happiness
    this.duration = duration
    this.durationUnit = durationUnit
    this.costMultiplicator = costMultiplicator
    this.productivityMultiplicator = productivityMultiplicator
    this.outAtEnd = outAtEnd
    this.outNow = outNow
    this.overwrite = overwrite
    this.appearanceRate = appearanceRate
    this.appearanceRule = appearanceRule
    this.available = available
  }
  
  static initOne() {
    return new HrStatus(null, 'Nouveau statut', 'Ceci est un nouveau statut', 'orange', ['female', 'male'], [], [0, 100], [1, 1], 'month', 1, 1, false, false, false, 5, 'random', true)
  }
  
  static getDefaultStatus() {
    return [
      new HrStatus('normal', 'Normal', 'Rien a signaler', 'brown', ['female', 'male'], [], [0, 100], [1, 1], 'month', 1, 1, false, false, false, 0, 'random', true),
      new HrStatus('hiring', 'Embauche', 'Ce collaborateur viens d\'etre embaucher', 'white', ['female', 'male'], [], [0, 100], [1, 1], 'month', 1, 1, false, false, false, 0, 'random', true),
      new HrStatus('firing', 'Licenciement', 'Ce collaborateur seras licencié a la fin du mois', 'white', ['female', 'male'], [], [0, 100], [1, 1], 'month', 1, 1, false, false, false, 0, 'random', true),
    ]
  } 

  async save() {
    const data = {
      name : this.name,
      description : this.description,
      color: this.color,
      sex : this.sex,
      jobs : this.jobs,
      happiness : this.happiness,
      duration : this.duration,
      durationUnit : this.durationUnit,
      costMultiplicator : this.costMultiplicator,
      productivityMultiplicator : this.productivityMultiplicator,
      outAtEnd : this.outAtEnd,
      outNow : this.outNow,
      overwrite : this.overwrite,
      appearanceRate : this.appearanceRate,
      appearanceRule : this.appearanceRule,
      available : this.available
    }

    if (this.id) {
      await catalogueCommands.hrStatus.update(this.id, data)
    } else {
      const result = await catalogueCommands.hrStatus.create(data)
      this.id = result.id
    }
    return this
  }

  async delete() {
    await catalogueCommands.hrStatus.delete(this.id)
  }

  static async listenAll(callback) {
    const docsQuery = query(collection(db, await getCollectionPath(collectionName)))
    onSnapshot(docsQuery, snapshot => {
      const list = []
      snapshot.forEach(document => {
        list.push(docToInstance(document))
      })
      callback(list)
    })
  }

  static async getAll(){
    const documents = await getDocs(collection(db, await getCollectionPath(collectionName)))
    return documents.docs.map(docToInstance)
  }
}
